function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { INPUT } from "../../components/form-styles";
import { listBlocks, createBlock, renameBlock, deleteBlock, isMissing, friendly } from "./compose-api";
import { SECTION_TYPES } from "./section-types";

/*
 * Saved blocks (2026-10-04): a section saved under a name for the workspace,
 * reinserted anywhere as a deep copy. One module-level cache so the add-menu
 * and the manager agree; `hidden` flips on 404/405/501 (route not shipped).
 */

const cache = {
  items: null,
  hidden: false,
  promise: null
};
export function blocksHidden() {
  return cache.hidden;
}
export function loadBlocks(force) {
  if (cache.hidden) return Promise.resolve([]);
  if (cache.items && !force) return Promise.resolve(cache.items);
  if (cache.promise && !force) return cache.promise;
  cache.promise = listBlocks().then(items => {
    cache.items = items;
    cache.promise = null;
    return items;
  }).catch(e => {
    cache.promise = null;
    if (isMissing(e)) {
      cache.hidden = true;
      cache.items = [];
      return [];
    }
    throw e;
  });
  return cache.promise;
}
function typeLabel(t) {
  return (SECTION_TYPES.find(([k]) => k === t) || [t, t])[1];
}

/** "Save as block…" for one section: a name prompt inline, then POST. */
export class SaveBlockButton extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      open: false,
      name: "",
      busy: false,
      note: null
    });
    _defineProperty(this, "_alive", true);
    _defineProperty(this, "save", async () => {
      const name = this.state.name.trim();
      if (!name) return;
      this.setState({
        busy: true,
        note: null
      });
      try {
        const b = await createBlock(name, JSON.parse(JSON.stringify(this.props.section)));
        if (cache.items) cache.items = [b, ...cache.items.filter(x => x.id !== b.id)];
        if (this._alive) this.setState({
          busy: false,
          open: false,
          name: "",
          note: {
            ok: true,
            text: `Saved as "${name}".`
          }
        });
      } catch (e) {
        if (!this._alive) return;
        if (isMissing(e)) {
          cache.hidden = true;
          this.setState({
            busy: false,
            open: false,
            note: {
              text: "Saved blocks arrive with the next mail service update."
            }
          });
          return;
        }
        this.setState({
          busy: false,
          note: {
            text: friendly(e, "The block couldn't be saved.")
          }
        });
      }
    });
  }
  componentWillUnmount() {
    this._alive = false;
  }
  render() {
    if (cache.hidden) return null;
    const {
      open,
      name,
      busy,
      note
    } = this.state;
    return /*#__PURE__*/React.createElement("span", {
      className: "cmp-saveblock"
    }, !open ? /*#__PURE__*/React.createElement("a", {
      className: "cmp-link",
      onClick: () => this.setState({
        open: true,
        note: null
      })
    }, "Save as block\u2026") : /*#__PURE__*/React.createElement("span", {
      className: "cmp-saveblock-form"
    }, /*#__PURE__*/React.createElement("input", {
      style: {
        ...INPUT,
        width: 180,
        padding: "3px 7px"
      },
      autoFocus: true,
      placeholder: "Block name",
      value: name,
      onChange: e => this.setState({
        name: e.target.value
      }),
      onKeyDown: e => {
        if (e.key === "Enter") this.save();
        if (e.key === "Escape") this.setState({
          open: false
        });
      }
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "territory-toggle",
      style: {
        marginTop: 0
      },
      disabled: busy || !name.trim(),
      onClick: this.save
    }, busy ? "Saving…" : "Save"), /*#__PURE__*/React.createElement("a", {
      className: "cmp-link dim",
      onClick: () => this.setState({
        open: false
      })
    }, "cancel")), note ? /*#__PURE__*/React.createElement("span", {
      className: "cmp-note" + (note.ok ? " ok" : "")
    }, note.text) : null);
  }
}

/** The "Insert saved block" panel in the add-section menu: search, insert, and a small Rename/Delete manager. */
export class InsertBlockPanel extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      items: null,
      err: null,
      q: "",
      manage: false,
      renaming: null,
      renameTo: "",
      busy: null
    });
    _defineProperty(this, "_alive", true);
    _defineProperty(this, "rename", async b => {
      const name = this.state.renameTo.trim();
      if (!name || name === b.name) {
        this.setState({
          renaming: null
        });
        return;
      }
      this.setState({
        busy: b.id
      });
      try {
        const nb = await renameBlock(b.id, name);
        cache.items = (cache.items || []).map(x => x.id === b.id ? {
          ...x,
          ...(nb || {}),
          name
        } : x);
        if (this._alive) this.setState({
          items: cache.items,
          renaming: null,
          busy: null
        });
      } catch (e) {
        if (this._alive) this.setState({
          busy: null,
          err: friendly(e, "Rename failed.")
        });
      }
    });
    _defineProperty(this, "del", async b => {
      this.setState({
        busy: b.id
      });
      try {
        await deleteBlock(b.id);
        cache.items = (cache.items || []).filter(x => x.id !== b.id);
        if (this._alive) this.setState({
          items: cache.items,
          busy: null,
          confirm: null
        });
      } catch (e) {
        if (this._alive) this.setState({
          busy: null,
          err: friendly(e, "Delete failed.")
        });
      }
    });
  }
  componentDidMount() {
    this.load();
  }
  componentWillUnmount() {
    this._alive = false;
  }
  load(force) {
    loadBlocks(force).then(items => this._alive && this.setState({
      items,
      err: null
    })).catch(e => this._alive && this.setState({
      items: [],
      err: friendly(e, "Saved blocks couldn't be listed right now.")
    }));
  }
  render() {
    const {
      items,
      err,
      q,
      manage,
      renaming,
      busy,
      confirm
    } = this.state;
    const {
      onInsert,
      onClose
    } = this.props;
    if (cache.hidden) return null;
    const t = q.trim().toLowerCase();
    const rows = (items || []).filter(b => !t || `${b.name} ${typeLabel(b.section && b.section.type)}`.toLowerCase().includes(t));
    return /*#__PURE__*/React.createElement("div", {
      className: "ec-picker cmp-blocks"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cmp-blocks-head"
    }, /*#__PURE__*/React.createElement("input", {
      style: INPUT,
      autoFocus: true,
      value: q,
      placeholder: "Search saved blocks",
      onChange: e => this.setState({
        q: e.target.value
      }),
      onKeyDown: e => {
        if (e.key === "Escape") onClose();
      }
    }), /*#__PURE__*/React.createElement("a", {
      className: "cmp-link",
      onClick: () => this.setState({
        manage: !manage,
        renaming: null
      })
    }, manage ? "Done" : "Manage")), err ? /*#__PURE__*/React.createElement("div", {
      className: "cmp-warn"
    }, err) : null, /*#__PURE__*/React.createElement("div", {
      className: "ec-picker-list"
    }, items == null ? /*#__PURE__*/React.createElement("div", {
      className: "territory-hint"
    }, "Loading\u2026") : !rows.length ? /*#__PURE__*/React.createElement("div", {
      className: "territory-hint"
    }, items.length ? "No block matches." : "No saved blocks yet. Open any section and choose \"Save as block…\".") : rows.map(b => /*#__PURE__*/React.createElement("div", {
      key: b.id,
      className: "cmp-block-row"
    }, renaming === b.id ? /*#__PURE__*/React.createElement("span", {
      className: "cmp-saveblock-form"
    }, /*#__PURE__*/React.createElement("input", {
      style: {
        ...INPUT,
        width: 200,
        padding: "3px 7px"
      },
      autoFocus: true,
      value: this.state.renameTo,
      onChange: e => this.setState({
        renameTo: e.target.value
      }),
      onKeyDown: e => {
        if (e.key === "Enter") this.rename(b);
        if (e.key === "Escape") this.setState({
          renaming: null
        });
      }
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "territory-toggle",
      style: {
        marginTop: 0
      },
      disabled: busy === b.id,
      onClick: () => this.rename(b)
    }, "Save"), /*#__PURE__*/React.createElement("a", {
      className: "cmp-link dim",
      onClick: () => this.setState({
        renaming: null
      })
    }, "cancel")) : /*#__PURE__*/React.createElement("button", {
      type: "button",
      disabled: !b.section,
      onClick: () => !manage && b.section && onInsert(JSON.parse(JSON.stringify(b.section))),
      title: manage ? undefined : "Insert a copy"
    }, /*#__PURE__*/React.createElement("span", null, b.name), /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, typeLabel(b.section && b.section.type), b.createdBy ? ` · ${b.createdBy}` : "")), manage && renaming !== b.id ? /*#__PURE__*/React.createElement("span", {
      className: "cmp-block-actions"
    }, /*#__PURE__*/React.createElement("a", {
      className: "cmp-link",
      onClick: () => this.setState({
        renaming: b.id,
        renameTo: b.name
      })
    }, "Rename"), confirm === b.id ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, "delete?"), /*#__PURE__*/React.createElement("a", {
      className: "cmp-link danger",
      onClick: () => this.del(b)
    }, busy === b.id ? "…" : "Yes"), /*#__PURE__*/React.createElement("a", {
      className: "cmp-link dim",
      onClick: () => this.setState({
        confirm: null
      })
    }, "no")) : /*#__PURE__*/React.createElement("a", {
      className: "cmp-link danger",
      onClick: () => this.setState({
        confirm: b.id
      })
    }, "Delete")) : null))), /*#__PURE__*/React.createElement("div", {
      className: "ec-picker-foot"
    }, /*#__PURE__*/React.createElement("a", {
      onClick: onClose
    }, "close")));
  }
}